<template>
  <div class="card mb-3">
    <div class="card-body">
      <h4 class="text-center">Add New Promo</h4>
      <div>
        <div class="d-flex justify-content-end mb-3">
          <div >
        <button
            class="btn btn-primary"
            @click="showPromoForm = true"
            type="button"
            v-if="!showPromoForm"
        >
          Add Promo
        </button>
          </div>
        </div>
        <div v-if="showPromoForm" class="pb-3">
          <h5>New Promo</h5>
          <form @submit.prevent="addPromo">
            <div class="d-flex gap-3">
              <div class="col-6">
                <div class="mb-3">
                  <label for="new_code" class="form-label">Promo Code</label>
                  <input
                      v-model="newPromo.code"
                      type="text"
                      class="form-control"
                      id="new_code"
                      placeholder="Enter promo code"
                  >
                  <p v-if="validationDiscountErrors?.code" v-for="code in validationDiscountErrors.code" class="text-danger">{{ code }}</p>

                </div>
                <div class="mb-3">
                  <label for="new_discount" class="form-label">Discount (%)</label>
                  <input
                      v-model="newPromo.discount"
                      type="number"
                      step="0.01"
                      class="form-control"
                      id="new_discount"
                      placeholder="Enter discount"
                  >
                  <p v-if="validationDiscountErrors?.discount" v-for="discount in validationDiscountErrors.discount" class="text-danger">{{ discount }}</p>

                </div>
                <div class="mb-3">
                  <label for="new_stop_date" class="form-label">Stop Date</label>
                  <input
                      v-model="newPromo.stop_date"
                      type="datetime-local"
                      class="form-control"
                      id="new_stop_date"
                  >
                  <p v-if="validationDiscountErrors?.stop_date" v-for="stop_date in validationDiscountErrors.stop_date" class="text-danger">{{ stop_date }}</p>

                </div>
                <div class="mb-3">
                  <label for="new_link_to_promo" class="form-label">Promo Link</label>
                  <input
                      v-model="newPromo.link_to_promo"
                      type="url"
                      class="form-control"
                      id="new_link_to_promo"
                      placeholder="Enter promo link"
                  >
                  <p v-if="validationDiscountErrors?.link_to_promo" v-for="link_to_promo in validationDiscountErrors.link_to_promo" class="text-danger">{{ link_to_promo }}</p>

                </div>
              </div>
              <div class="w-100">
                <div class="mb-3 d-flex flex-column">
                  <label class="form-label">Description</label>
                  <div v-for="(desc, descIndex) in newPromo.descriptions" :key="descIndex" class="mb-3">
                    <div class="d-flex gap-2 flex-column align-items-center">
                      <div class="d-flex gap-3 w-100">
                        <select
                            v-model="desc.lang"
                            class="form-control"
                            @change="updateNewPromoDescription(descIndex)"
                            required
                        >
                          <option value="" disabled>Select language</option>
                          <option
                              v-for="(lang, code) in availableLanguages(descIndex, newPromo.descriptions)"
                              :key="code"
                              :value="code"
                          >
                            {{ lang.name }}
                          </option>
                        </select>
                        <button
                            type="button"
                            class="btn btn-danger ms-2"
                            @click="removeNewPromoDescription(descIndex)"
                            :disabled="loading.languages || loading.newPromo"

                        >
                          Remove
                        </button>
                      </div>
                      <textarea
                          v-model="desc.name"
                          class="form-control"
                          placeholder="Enter description"
                          @input="updateNewPromoDescription(descIndex)"
                          rows="4"
                          required
                      ></textarea>
                      <p v-if="validationDiscountErrors?.description" v-for="description in validationDiscountErrors.description" class="text-danger">{{ description }}</p>
                    </div>
                  </div>
                  <button
                      class="btn btn-primary mb-3"
                      @click="addNewPromoDescription"
                      type="button"
                      :disabled="loading.languages || loading.newPromo"

                  >
                    Add language
                  </button>
                </div>
              </div>
            </div>
            <div v-if="newPromoErrors.length" class="alert alert-danger mt-2">
              <p v-for="(error, index) in newPromoErrors" :key="index">{{ error }}</p>
            </div>
            <div class="d-flex justify-content-end gap-2">
              <button
                  type="button"
                  class="btn btn-secondary"
                  @click="cancelForm"
              >
                Cancel
              </button>
              <button
                  type="submit"
                  class="btn btn-success"
                  :disabled="loading.newPromo"
              >
                {{ loading.newPromo ? 'Adding...' : 'Save Promo' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div v-for="promo in partnerDiscount" :key="promo.id" class="card mb-3">
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div></div>
        <h4 class="text-center">Promo for {{ promo.partner?.name || 'Partner' }}</h4>
        <div class="d-flex gap-1 align-items-center">
          <label class="form-label">Copy Counter</label>
          <h5>{{promo.copy_counter}}</h5>
        </div>
      </div>

      <form @submit.prevent="savePromo(promo.id)">
        <div class="d-flex gap-3">
          <div class="col-6">
            <div class="mb-3">
              <label :for="'code-' + promo.id" class="form-label">Promo Code</label>
              <input
                  v-model="promo.code"
                  type="text"
                  class="form-control"
                  :id="'code-' + promo.id"
                  placeholder="Enter promo code"
              >
              <p v-if="validationDiscountErrors?.code" v-for="code in validationDiscountErrors.code" class="text-danger">{{ code }}</p>
            </div>
            <div class="mb-3">
              <label :for="'discount-' + promo.id" class="form-label">Discount (%)</label>
              <input
                  v-model="promo.discount"
                  type="number"
                  step="0.01"
                  class="form-control"
                  :id="'discount-' + promo.id"
                  placeholder="Enter discount"
              >
              <p v-if="validationDiscountErrors?.discount" v-for="discount in validationDiscountErrors.discount" class="text-danger">{{ discount }}</p>
            </div>
            <div class="mb-3">
              <label :for="'stop_date-' + promo.id" class="form-label">Stop Date</label>
              <input
                  :value="formatDateForInput(promo.stop_date)"
                  @input="promo.stop_date = $event.target.value"
                  type="datetime-local"
                  class="form-control"
                  :id="'stop_date-' + promo.id"
              >
              <p v-if="validationDiscountErrors?.stop_date" v-for="stop_date in validationDiscountErrors.stop_date" class="text-danger">{{ stop_date }}</p>
            </div>
            <div class="mb-3">
              <label :for="'link_to_promo-' + promo.id" class="form-label">Promo Link</label>
              <input
                  v-model="promo.link_to_promo"
                  type="url"
                  class="form-control"
                  :id="'link_to_promo-' + promo.id"
                  placeholder="Enter promo link"
              >
              <p v-if="validationDiscountErrors?.link_to_promo" v-for="link_to_promo in validationDiscountErrors.link_to_promo" class="text-danger">{{ link_to_promo }}</p>
            </div>

          </div>
          <div class="w-100">
            <div class="mb-3 d-flex flex-column">
              <label class="form-label">Description</label>
              <div v-for="(desc, index) in promo.descriptions" :key="index" class="mb-3">
                <div class="d-flex gap-2 flex-column align-items-center">
                  <div class="d-flex gap-3 w-100">
                    <select
                        v-model="desc.lang"
                        class="form-control"
                        @change="updatePromoDescription(promo, index)"
                    >
                      <option value="" disabled>Select language</option>
                      <option
                          v-for="(lang, code) in availableLanguages(index, promo.descriptions)"
                          :key="code"
                          :value="code"
                      >
                        {{ lang.name }}
                      </option>
                    </select>
                    <button
                        type="button"
                        class="btn btn-danger ms-2"
                        @click="removePromoDescription(promo, index)"
                    >
                      Remove
                    </button>
                  </div>
                  <textarea
                      v-model="desc.name"
                      class="form-control"
                      placeholder="Enter description"
                      @input="updatePromoDescription(promo, index)"
                      rows="4"
                  ></textarea>
                </div>
              </div>
              <button
                  class="btn btn-primary mb-3"
                  @click="addPromoDescription(promo)"
                  type="button"
                  :disabled="!Object.keys(availableLanguages(promo.descriptions.length, promo.descriptions)).length"
              >
                Add language
              </button>
            </div>
          </div>
        </div>
        <div v-if="errors[promo.id]" class="alert alert-danger">
          <p v-for="(error, index) in errors[promo.id]" :key="index">{{ error }}</p>
        </div>
        <div class="d-flex justify-content-end gap-2">
          <button type="submit" class="btn btn-success" :disabled="loading[promo.id]">
            {{ loading[promo.id] ? 'Saving...' : 'Save' }}
          </button>
          <button
              type="button"
              class="btn btn-danger"
              @click="deletePromo(promo.id)"
              :disabled="loading[promo.id]"
          >
            Delete
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@fortawesome/fontawesome-free/css/all.css';

export default {
  name: 'PartnerDiscount',
  components: { FontAwesomeIcon, QuillEditor },
  props: {
    partnerId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      validationDiscountErrors: [],
      partnerDiscount: [],
      languages: {},
      loading: {},
      errors: {},
      newPromo: {
        code: null,
        descriptions: [{ lang: '', name: '' }],
        discount: null,
        stop_date: null,
        link_to_promo: null,
        copy_counter: "0",
      },
      newPromoErrors: [],
      showPromoForm: false
    };
  },
  methods: {
    async getLanguages() {
      this.loading.languages = true;
      try {
        const response = await axios.get(`/admin/languages`);
        this.languages = response.data;
      } catch (error) {
        console.error('Error fetching languages:', error);
        this.errors.global = ['Failed to load languages'];
      } finally {
        this.loading.languages = false;
      }
    },
    async getPartnerDiscount() {
      this.loading.global = true;
      try {
        const response = await axios.get(`/admin/partner-discounts`, {
          params: { partner_id: +this.partnerId }
        });
        this.partnerDiscount = (response.data.data || []).map(promo => ({
          ...promo,
          descriptions: Object.entries(promo.description || {}).filter(([_, desc]) => desc && typeof desc === 'object' && desc.name).map(([lang, desc]) => ({
            lang,
            name: desc.name || ''
          }))
        }));
      } catch (error) {
        console.error('Error fetching partner discounts:', error);
        this.errors.global = ['Failed to load promos'];
      } finally {
        this.loading.global = false;
      }
    },
    async savePromo(promoId) {
      this.validationDiscountErrors = []
      const promo = this.partnerDiscount.find(p => p.id === promoId);
      if (!promo) {
        console.error('Promo not found for id:', promoId);
        return;
      }

      if (!promo.descriptions) {
        this.errors[promoId] = ['All required fields must be filled'];
        return;
      }

      this.loading[promoId] = true;
      this.errors[promoId] = null;

      try {
        const payload = {
          code: promo.code,
          description: promo.descriptions.reduce((acc, { lang, name }) => {
            if (lang && name) {
              acc[lang] = { name };
            }
            return acc;
          }, {}),
          discount: promo.discount != null ? parseFloat(promo.discount) : null,
          stop_date: promo.stop_date ? new Date(promo.stop_date).toISOString() : null,
          link_to_promo: promo.link_to_promo || null,
          partner_id: +this.partnerId
        };

        await axios.patch(`/admin/partner-discounts/${promoId}`, payload);
        alert('Promo updated successfully');
      } catch (error) {
        if (error.response?.status === 422) {
          this.validationDiscountErrors = error.response.data.errors;
        } else {
          console.error('Error creating partner:', error);
        }
      } finally {
        this.loading[promoId] = false;
      }
    },
    async deletePromo(promoId) {
      if (!confirm('Are you sure you want to delete this promo?')) return;

      this.loading[promoId] = true;
      this.errors[promoId] = null;

      try {
        await axios.delete(`/admin/partner-discounts/${promoId}`);
        this.partnerDiscount = this.partnerDiscount.filter(p => p.id !== promoId);
      } catch (error) {
        this.errors[promoId] = ['Failed to delete promo'];
        console.error('Error deleting promo:', error);
      } finally {
        this.loading[promoId] = false;
      }
    },
    async addPromo() {
      this.newPromoErrors = [];
      this.validationDiscountErrors = [];
      this.loading.newPromo = true;

      if (!this.newPromo.descriptions) {
        this.newPromoErrors = ['All required fields must be filled'];
        this.loading.newPromo = false;
        return;
      }

      if (this.newPromo.link_to_promo && !/^https?:\/\/[^\s$.?#].[^\s]*$/.test(this.newPromo.link_to_promo)) {
        this.newPromoErrors = ['Invalid promo link format'];
        this.loading.newPromo = false;
        return;
      }

      const payload = {
        code: this.newPromo.code,
        description: this.newPromo.descriptions.reduce((acc, { lang, name }) => {
          if (lang && name) {
            acc[lang] = { name };
          }
          return acc;
        }, {}),
        discount: this.newPromo.discount != null ? parseFloat(this.newPromo.discount) : null,
        stop_date: this.newPromo.stop_date ? new Date(this.newPromo.stop_date).toISOString() : null,
        link_to_promo: this.newPromo.link_to_promo || null,
        partner_id: +this.partnerId
      };

      try {
        const response = await axios.post(`/admin/partner-discounts`, payload);
        const promoData = response.data.data || response.data;
        if (!promoData) {
          throw new Error('Invalid response structure: no promo data');
        }

        const descriptions = promoData.description && typeof promoData.description === 'object'
            ? Object.entries(promoData.description)
                .filter(([_, desc]) => desc && typeof desc === 'object' && desc.name)
                .map(([lang, desc]) => ({
                  lang,
                  name: desc.name || ''
                }))
            : [];

        this.partnerDiscount.push({
          ...promoData,
          descriptions
        });

        this.newPromo = {
          code: null,
          descriptions: [{ lang: '', name: '' }],
          discount: null,
          stop_date: null,
          link_to_promo: null
        };
        this.newPromoErrors = [];
        this.showPromoForm = false;
        alert('Promo added successfully');
      } catch (error) {
        if (error.response?.status === 422) {
          this.validationDiscountErrors = error.response.data.errors;
        } else {
          console.error('Error creating partner:', error);
        }
      } finally {
        this.loading.newPromo = false;
      }
    },
    cancelForm() {
      this.newPromo = {
        code: null,
        descriptions: [{ lang: '', name: '' }],
        discount: null,
        stop_date: null,
        link_to_promo: null
      };
      this.newPromoErrors = [];
      this.showPromoForm = false;
    },
    formatDateForInput(isoDate) {
      return isoDate ? new Date(isoDate).toISOString().slice(0, 16) : '';
    },
    addPromoDescription(promo) {
      promo.descriptions.push({ lang: '', name: '' });
    },
    removePromoDescription(promo, index) {
      promo.descriptions.splice(index, 1);
      this.updatePromoDescription(promo);
    },
    updatePromoDescription(promo) {
      promo.description = promo.descriptions.reduce((acc, { lang, name }) => {
        if (lang && name) {
          acc[lang] = { name };
        }
        return acc;
      }, {});
    },
    addNewPromoDescription() {
      this.newPromo.descriptions.push({ lang: '', name: '' });
    },
    removeNewPromoDescription(descIndex) {
      this.newPromo.descriptions.splice(descIndex, 1);
      this.updateNewPromoDescription();
    },
    updateNewPromoDescription() {
      this.newPromo.description = this.newPromo.descriptions.reduce((acc, { lang, name }) => {
        if (lang && name) {
          acc[lang] = { name };
        }
        return acc;
      }, {});
    }
  },
  computed: {
    availableLanguages() {
      return (index, descriptions) => {
        const usedLangs = descriptions
            .filter((_, i) => i !== index)
            .map(desc => desc.lang)
            .filter(lang => lang);
        return Object.fromEntries(
            Object.entries(this.languages).filter(([code]) => !usedLangs.includes(code))
        );
      };
    }
  },
  mounted() {
    if (this.partnerId) {
      this.getLanguages();
      this.getPartnerDiscount();
    }
  }
};
</script>
